import { Inject, Injectable } from '@angular/core';
import { UserApiController } from '../api-controllers/user.api-controller';
import { Locale } from '@magieno/common';
import { UserIdentityInterface } from '../../../../../../../common/dist/angular/interfaces/user-identity.interface';
import { AuthService } from '@auth0/auth0-angular';
import { LoggingService } from '../../core/services/logging.service';
import { UserLocaleUpdateOptions } from '../../../../../../../common/dist/angular/options/user-locale-update.options';

@Injectable()
export class LocaleService {

  constructor(private readonly userApiController: UserApiController,
              private authService: AuthService,
              private loggingService: LoggingService,
              @Inject('environment.auth0.audience') private readonly auth0Audience: string) {
  }

  async getLocaleForUser(): Promise<Locale> {
    return Locale.fr;

    // todo for now we only support fr
    // let userLocale: string;
    // try {
    //     userLocale = localStorage.getItem("userLocale");
    //     if (!userLocale) {
    //         const token = await this.authService.idTokenClaims$.pipe(take(1)).toPromise();
    //         if (token) {
    //             userLocale = token[this.auth0Audience + "/appConfig"]?.locale;
    //             if (userLocale) {
    //                 console.log("Using locale from app metadata", userLocale)
    //             }
    //         }
    //         if (!userLocale) {
    //             userLocale = window.navigator.language;
    //             console.log("Using locale from navigator", userLocale)
    //         } else {
    //             localStorage.setItem("userLocale", userLocale);
    //         }
    //     }
    // } catch (e) {
    //     console.error("Error getting locale for user, defaulting to fr");
    //     userLocale = Locale.fr;
    // }
    // return this.convertToLocaleEnum(userLocale);
  }

  async setLocaleForUser(locale: Locale): Promise<UserIdentityInterface> {
    localStorage.setItem('userLocale', locale);
    const userLocaleUpdateOptions: UserLocaleUpdateOptions = new UserLocaleUpdateOptions();
    userLocaleUpdateOptions.locale = locale;
    return this.userApiController.updateLocale(userLocaleUpdateOptions);
  }

  removeLocaleForUser(): void {
    localStorage.removeItem('userLocale');
  }

  private convertToLocaleEnum(userLocale: string): Locale {
    switch (userLocale.toLowerCase()) {
      case 'en-us':
      case 'en-ca':
      case 'en':
        return Locale.en;
      case 'fr-ca':
      case 'fr':
        return Locale.fr;
      default:
        this.loggingService.error('Locale not supported, defaulting to fr.');
        return Locale.fr;
    }
  }
}
